import { render } from "./ProductPricesPage.vue?vue&type=template&id=0fc9772e&scoped=true"
import script from "./ProductPricesPage.vue?vue&type=script&lang=js"
export * from "./ProductPricesPage.vue?vue&type=script&lang=js"

import "./ProductPricesPage.vue?vue&type=style&index=0&id=0fc9772e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc9772e"]])

export default __exports__